<div *ngxPermissionsOnly="'CONVERSATION_READ_ALL'">
  <div
    class="edit-screen-header"
    layout="row"
    layout-wrap
    layout-align="space-between"
  >
    <div
      flex-gt-md="33"
      flex-gt-sm="50"
      flex="50"
      layout="row"
      layout-align-gt-md="space-between end"
      layout-align="space-between end"
    >
      <span class="edit-screen-title" [translate]="'communication.smsList'"
        >SMS</span
      >
    </div>
    <div
      flex-gt-md="33"
      flex-gt-sm="50"
      flex="50"
      layout="row"
      layout-align-gt-md="end end"
      layout-align="end end"
    >
      <div class="add-margin-left">
        <button
          [disabled]="['SMS_SEND'] | isUnauthorized | async"
          mat-raised-button
          type="button"
          (click)="sendNewSms($event)"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
      @if (credit) {
        <mat-slide-toggle
          labelPosition="before"
          (change)="onSmsModeChange($event)"
        >
          <span [translate]="'communication.showAll'">Show All</span>
        </mat-slide-toggle>
      }
    </div>
  </div>
  <mat-card appearance="outlined">
    <mat-card-content>
      @if (smsLoading) {
        <div class="progress-spinner-container">
          <mat-spinner
            class="progress-spinner"
            strokeWidth="10"
            [diameter]="150"
          ></mat-spinner>
        </div>
      }
      <div [hidden]="smsLoading">
      <itfg-data-table [data]="smsPage?.content" [columns]="smsColumns">
        <ng-template itfgDataTableTemplate="user_id" let-value="value">
          <itfg-brand-logo
            [brand]="getBrandByUserId(value)"
            size="18px"
          ></itfg-brand-logo>
        </ng-template>
        <ng-template
          itfgDataTableTemplate="credit_id"
          let-value="value"
          let-row="row"
          let-column="column"
        >
          <div
            [itfgHighlightDataTableRow]="includeAllSms && value == credit?.id"
          >
            <!-- <div> -->
            @if (value) {
              <a target="_blank" [routerLink]="['/credits', value]">{{
                value
              }}</a>
            }
          </div>
        </ng-template>
        <ng-template
          itfgDataTableTemplate="delivery_status"
          let-value="value"
          let-row="row"
          let-column="column"
        >
          <div
            class="table-cell-overflow-ellipsis"
            matTooltipPosition="above"
            [matTooltip]="value"
          >
            @if (!!value) {
              <span>{{
                'communication.deliveryStatus.' + value | translate
              }}</span>
            }
          </div>
        </ng-template>
        <ng-template
          itfgDataTableTemplate="body"
          let-value="value"
          let-row="row"
          let-column="column"
        >
          <div
            class="table-cell-overflow-ellipsis"
            matTooltipPosition="above"
            [matTooltip]="value"
          >
            <span>{{ value }}</span>
          </div>
        </ng-template>
        <ng-template itfgDataTableTemplate="sent_at" let-row="row">
          <itfg-date-format
            [matTooltip]="
              !row.sent_at && row.scheduled_at
                ? ('templates.scheduledAtMessage'
                  | translate
                    : { scheduleTime: (row.scheduled_at | itfgDateFormat) })
                : null
            "
            [date]="row.sent_at"
          ></itfg-date-format>
        </ng-template>
        <ng-template
          itfgDataTableTemplate="actions"
          let-value="value"
          let-row="row"
          let-column="column"
        >
          <!-- <div layout="row">
          <button [disabled]="['SMS_SEND'] | isUnauthorized | async"
            mat-icon-button
            flex
            (click)="resendSms(row.id)">
            <mat-icon matTooltip="{{ 'communication.resendSms' | translate }}"
              matTooltipShowDelay="500"
              matTooltipPosition="above">refresh
            </mat-icon>
          </button>
        </div> -->
        </ng-template>
      </itfg-data-table>
      <mat-paginator
        #pagingBarResponsive
        (page)="pageChanged($event)"
        [pageIndex]="searchOptions.page"
        [length]="smsPage.totalElements"
        [pageSize]="searchOptions.pageSize"
        [pageSizeOptions]="[5, 20, 30, 100]"
        showFirstLastButtons
      >
      </mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>
